var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center w-100 h-100"},[_c('div',{staticClass:"font-size-h2 text-header-color text-center px-4"},[_vm._v("KIOSK IS CURRENTLY NOT AVAILABLE.")])])
}]

export { render, staticRenderFns }